import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useNavLayerEnableMutation } from "@/v2-backoffice-client/navlayer/enable/navlayer.enable.mutation"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerEnableMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  navLayer: NavLayerFragment
}

function NavLayerEnableMenuItem(props: NavLayerEnableMenuItemProps) {
  const { navLayer, children, ...menuItemProps } = props

  const [toggle, { loading, error }] = useNavLayerEnableMutation()

  const isEnabled = navLayer.IsEnabled

  return (
    <ActionMenu.Item
      iconSrc={isEnabled ? "eye-crossed" : "eye"}
      isLoading={loading}
      error={error}
      errorTitle="Failed to toggle nav layer"
      onSelect={(event) => {
        event.preventDefault()
        toggle({
          variables: {
            featureCode: navLayer.FeatureCode,
            isEnabled: !isEnabled,
          },
        })
      }}
      {...menuItemProps}
    >
      {children ?? (isEnabled ? "Disable Nav Layer" : "Enable Nav Layer")}
    </ActionMenu.Item>
  )
}

export default NavLayerEnableMenuItem
